module.exports = __webpack_public_path__ + "img/ele-900w.acfbe79d.jpg";